App.filter('prepareRights', ['$rootScope', function ($rootScope) {
    return function (right) {
        right = right || '';

        if ($rootScope.__rights.indexOf(right) > -1) {
            return true;
        }

        return false;
    };
}]);